/* Invoices (M5) — multi-month, with reconciliation + dispute-lifecycle fields
   (verbatim generator from mockup core.js). */
import {SUPPLY_DATA} from './_v6Data'

export const DUMMY_INVOICES = SUPPLY_DATA.invoices
